import {
  Checkbox,
  createTheme,
  ThemeProvider,
  Tooltip,
  withStyles
} from '@material-ui/core';
import React, { useMemo } from 'react';
import flowRight from 'lodash.flowright';
import clsx from 'clsx';

import styles from '../styles/checkboxRow';
import withSettings from '../../../utils/withSettings';
import Optional from '../../../utils/optional';
import { isDefined } from '../../../utils/isDefined';

const CheckboxRow = ({
  label,
  type,
  classes,
  width,
  values = [],
  disabled,
  settings,
  infoIcon = false,
  infoIconTooltipComponent = void 0,
  infoIconText = '',
  checkBoxTooltip,
  changeValue = () => {}
}) => {
  const theme = createTheme({
    overrides: {
      MuiSvgIcon: { root: { fontSize: '25px' } },
      MuiCheckbox: {
        root: {
          fontSize: '20px',
          '&$disabled': {
            pointerEvents: 'auto'
          }
        },
        colorSecondary: {
          color: settings.colors.modal_header,
          '&$checked': { color: settings.colors.modal_header }
        }
      },
      MuiTooltip: {
        tooltip: {
          fontSize: '12px',
          width: '200px'
        }
      }
    }
  });

  const value = useMemo(() => {
    const elExits = values.find(el => el.type === type);
    return isDefined(elExits) ? true : false;
  }, [type, values]);

  return (
    <div
      className={classes.checkboxRoot}
      style={{ minWidth: width ? `${width}px` : '260px' }}
    >
      <ThemeProvider theme={theme}>
        <Tooltip title={Optional(checkBoxTooltip).or('')}>
          <Checkbox
            checked={Optional(value).or(false)}
            disabled={disabled}
            onChange={e => changeValue(type, e.target.checked)}
          />
        </Tooltip>
      </ThemeProvider>
      <div className={classes.label}>
        {label}
        {infoIcon && (
          <Tooltip title={Optional(infoIconTooltipComponent).or(infoIconText)}>
            <i className={clsx('fas fa-info-circle', classes.infoIcon)}></i>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default flowRight(withSettings, withStyles(styles))(CheckboxRow);
